import React from "react";
import {Container, Row, Spinner} from "react-bootstrap";

type LoadingSpinnerProps = {
    className?: string;
  };

  export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
    return (
        <Container> 
            <center>
            <Spinner animation="border" role="status" 
                className={className ?? "m-3"}>
                <span className="visually-hidden">Loading...</span>
            </Spinner>  
            </center>
        </Container>
    )
}